export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Date.now() / 1000; // segundos
    return payload.exp < now;
  } catch (err) {
    return true; // se der erro, considera expirado
  }
}